import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalBase from './ModalBase';
import ModalPortal from './ModalPortal';
import { colors } from '@vds-core/theme';
import cuid from 'cuid';

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showModal: false,
      unmounted: false,
      keyPress: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.showModal || _this.props.opened) {
        _this.setState({
          showModal: true,
          unmounted: false
        });

        _this.handelShowChanged();
      } // Hooray for iOS13 that it doesn't decipher between iPad Safari and Desktop Safari by default


      var isIPAD = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream;
      var isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini|Mobile|mobile/i.test(navigator.userAgent);
      _this.isAppleDevice = /iPhone|iPad/i.test(navigator.userAgent);
      _this.isMobileDevice = isIPAD || isMobileDevice;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this.unMountTimer);
      if (_this.props.preventBackButton) _this.unRegisterOverride();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (typeof (_this.props.showModal || _this.props.opened) !== 'undefined' && (_this.props.showModal !== prevProps.showModal || _this.props.opened !== prevProps.opened)) {
        if (_this.props.showModal !== _this.state.showModal || _this.props.opened !== _this.state.showModal) {
          _this.toggleModal();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleId", "toggle-".concat(cuid()));

    _defineProperty(_assertThisInitialized(_this), "onUnload", function () {
      if (_this.state.showModal) {
        _this.setState({
          showModal: false
        });

        window.removeEventListener('popstate', _this.onUnload);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "registerOverride", function () {
      //Disable browser back button when the modal is launched
      history.pushState(null, null);
      window.addEventListener('popstate', _this.onUnload);
    });

    _defineProperty(_assertThisInitialized(_this), "unRegisterOverride", function () {
      window.removeEventListener('popstate', _this.onUnload);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      var showModal = _this.state.showModal;
      var toggleButton = _this.props.toggleButton;

      _this.handelShowChanged();

      if (showModal) {
        _this.setState({
          unmounted: true
        });

        _this.unMountTimer = setTimeout(function () {
          _this.setState({
            showModal: false
          });

          toggleButton && document.getElementById(_this.toggleId).focus();
        }, 401);
        if (_this.props.preventBackButton) _this.unRegisterOverride();
        return;
      }

      if (_this.props.preventBackButton) _this.registerOverride();

      _this.setState({
        showModal: true,
        unmounted: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handelShowChanged", function () {
      var showModal = !_this.state.showModal;

      if (_this.props.showModalChanged) {
        _this.props.showModalChanged(showModal);
      }

      if (_this.props.onOpenedChange) {
        _this.props.onOpenedChange(showModal);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e, toggleButton) {
      _this.toggleModal();

      toggleButton.props.onClick && toggleButton.props.onClick(e);

      if (e.detail === 0) {
        _this.setState({
          keyPress: true
        });
      } else {
        _this.setState({
          keyPress: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderToggle", function () {
      // Check if a Toggle Element was passed in
      if (!_this.props.toggleButton) {
        return null;
      }

      return /*#__PURE__*/React.cloneElement(_this.props.toggleButton, {
        onClick: function onClick(e) {
          return _this.handleClick(e, _this.props.toggleButton);
        },
        id: _this.toggleId
      });
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "getCloseButton",
    value: function getCloseButton(props) {
      var closeButton = props.closeButton,
          styleConfig = props.styleConfig && props.styleConfig.closeButton; //if null return null so close button isnt rendered, props.showCloseButton for backwards compatibility

      if (closeButton === null && (props.showCloseButton === false || props.showCloseButton === undefined)) {
        return null;
      } // Check for no Header Close Button


      if (typeof closeButton === 'undefined') {
        return undefined;
      } // Check for Custom Header Close Button with NO onClick function


      if (closeButton && typeof closeButton.props.onClick === 'undefined') {
        return /*#__PURE__*/React.cloneElement(closeButton, {
          onClick: this.toggleModal,
          styleConfig: styleConfig && styleConfig.closeButton
        });
      } else {
        return /*#__PURE__*/React.cloneElement(closeButton, {
          styleConfig: styleConfig && styleConfig.closeButton
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var unmounted = this.state.unmounted;
      var _this$props = this.props,
          ariaLabel = _this$props.ariaLabel,
          className = _this$props.className,
          disableOutsideClick = _this$props.disableOutsideClick,
          showModalChanged = _this$props.showModalChanged,
          onOpenedChange = _this$props.onOpenedChange,
          hideCloseButton = _this$props.hideCloseButton,
          customScroll = _this$props.customScroll,
          toggleButton = _this$props.toggleButton,
          viewport = _this$props.viewport,
          styleConfig = _this$props.styleConfig,
          fullScreenDialog = _this$props.fullScreenDialog,
          fixedCloseButton = _this$props.fixedCloseButton,
          animationDistance = _this$props.animationDistance,
          colorConfig = _this$props.colorConfig,
          zIndex = _this$props.zIndex,
          id = _this$props.id,
          analyticsTrack = _this$props['data-analyticstrack'],
          clickStream = _this$props['data-clickstream'];
      var children = React.Children.map(this.props.children, function (child, index) {
        if (child && /*#__PURE__*/React.isValidElement(child) && child.type && child.type.name && child.type.name === 'ModalFooter') {
          return /*#__PURE__*/React.cloneElement(child, {
            toggleModal: _this2.toggleModal,
            key: index + 1
          });
        } else {
          return child;
        }
      });
      return /*#__PURE__*/React.createElement(Fragment, null, toggleButton && this.renderToggle(), /*#__PURE__*/React.createElement(ModalPortal, {
        isAppleDevice: this.isAppleDevice
      }, /*#__PURE__*/React.createElement(ModalBase, {
        id: id,
        zIndex: zIndex,
        tabIndex: 0,
        ariaLabel: ariaLabel,
        className: className,
        closeButton: this.getCloseButton(this.props),
        showCloseButton: this.getCloseButton(this.props),
        hideCloseButton: hideCloseButton,
        customScroll: customScroll,
        disableOutsideClick: disableOutsideClick,
        showModal: this.state.showModal,
        opened: true,
        handleKeypress: this.handleKeypress,
        showModalChanged: showModalChanged,
        onOpenedChange: onOpenedChange,
        toggleModal: this.toggleModal,
        unmounted: unmounted,
        modalHeight: this.props.modalHeight,
        modalWidth: this.props.modalWidth,
        isMobileDevice: this.isMobileDevice,
        isAppleDevice: this.isAppleDevice,
        viewport: viewport,
        styleConfig: styleConfig,
        fullScreenDialog: fullScreenDialog,
        fixedCloseButton: fixedCloseButton,
        animationDistance: animationDistance,
        colorConfig: colorConfig,
        analyticsTrack: analyticsTrack,
        clickStream: clickStream,
        keyPress: this.state.keyPress
      }, children)));
    }
  }]);

  return Modal;
}(React.Component);
/** @component */


_defineProperty(Modal, "propTypes", {
  /**
   * Enables custom scrollbar when content overflows
   */
  customScroll: PropTypes.bool,

  /**
   * A label describing the Modal's current content
   */
  ariaLabel: PropTypes.string.isRequired,

  /**
   *	React components or HTML elements that will be in the Modal.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   * Names of classes to be added to the AccordionDetail <code>class</code> attribute.
   */
  className: PropTypes.string,

  /**
   *
   * If provided, the Close Button in the Title Area of the Modal will be replaced with this React Component.<br><br>There are 3 possible value types for this Property:<ul><li><strong>undefined</strong> - Ignored, and uses Modal Default Close Button.</li><li><strong>null</strong> - Do NOT display any Close Button.</li><li><strong>node</strong> - A React Component that will replace the Default Close Button.</li></ul><strong>Note: </strong>You can provide an <code>onClick()</code> function to provide custom behavior for the Header Close Button. However, you will then be responsible for closing the Modal. If you do not provide the <code>onClick()</code> function, the default Modal function will be used, and it will simply close the Modal.
   */
  closeButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @deprecated
   * If provided, the Close Button in the Title Area of the Modal will be replaced with this React Component.<br><br>There are 3 possible value types for this Property:<ul><li><strong>undefined</strong> - Ignored, and uses Modal Default Close Button.</li><li><strong>null</strong> - Do NOT display any Close Button.</li><li><strong>node</strong> - A React Component that will replace the Default Close Button.</li></ul><strong>Note: </strong>You can provide an <code>onClick()</code> function to provide custom behavior for the Header Close Button. However, you will then be responsible for closing the Modal. If you do not provide the <code>onClick()</code> function, the default Modal function will be used, and it will simply close the Modal.
   */
  showCloseButton: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /**
   * @deprecated
   * Boolean that hides the close button.
   */
  hideCloseButton: PropTypes.bool,

  /**
   * If true, clicks outside of the Modal (the overlay) will not cause a close.
   */
  disableOutsideClick: PropTypes.bool,

  /**
   * @deprecated
   * Boolean or a Function that returns true or false. This Property can be used instead of the <code>toggleButton</code> to show or hide the Modal.<br><br><strong>Note: </strong>Either the <code>toggleButton</code> or the <code>showModal</code> should be used, but not both. Using both will result in unexpected behavior
   */
  showModal: PropTypes.bool,

  /**
   * Boolean or a Function that returns true or false. This Property can be used instead of the <code>toggleButton</code> to show or hide the Modal.<br><br><strong>Note: </strong>Either the <code>toggleButton</code> or the <code>opened</code> should be used, but not both. Using both will result in unexpected behavior.
   */
  opened: PropTypes.bool,

  /**
   * @deprecated
   * If you provide a Function to this Property, it will be called whenever the <code>showModal</code> state changes in Modal. It fires after the state changes in the Modal, and it provides the new state of the<code>showModal</code>. This is provided so that you can maintain the visible status of the Modal externally.<br><br>It would typically be used in conjunction with the <code>showModal</code>attribute, and/or any Function provided to the <code>onClick()</code>attribute you provided via the <code>closeButton</code> Property.
   */
  showModalChanged: PropTypes.func,

  /**
   * If you provide a Function to this Property, it will be called whenever the <code>opened</code> state changes in Modal. It fires after the state changes in the Modal, and it provides the new state of the<code>opened</code>. This is provided so that you can maintain the visible status of the Modal externally.<br><br>It would typically be used in conjunction with the <code>opened</code> attribute, and/or any Function provided to the <code>onClick()</code> attribute you provided via the <code>showCloseButton</code> Property.
   */
  onOpenedChange: PropTypes.func,

  /**
   * @ignore
   * */
  title: PropTypes.element,

  /**
   * React component or HTML element that can be used to toggle Modal.
   */
  toggleButton: PropTypes.element,

  /**
   * z index value for modal
   */
  zIndex: PropTypes.number,

  /**
   * @ignore
   */
  modalHeight: PropTypes.string,

  /**
   * @ignore
   */
  modalWidth: PropTypes.string,

  /**
   * Viewport to configure how the modal will be rendered.
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   */
  fullScreenDialog: PropTypes.bool,

  /**
   * @ignore
   */
  fixedCloseButton: PropTypes.bool,

  /**
   * @ignore
   */
  preventBackButton: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
});

_defineProperty(Modal, "defaultProps", {
  title: null,
  className: null,
  toggleButton: null,
  closeButton: undefined,
  showCloseButton: undefined,
  hideCloseButton: false,
  customScroll: false,
  showModal: undefined,
  opened: undefined,
  showModalChanged: undefined,
  onOpenedChange: undefined,
  disableOutsideClick: undefined,
  modalHeight: undefined,
  modalWidth: undefined,
  zIndex: 999,
  //1.0 props
  viewport: 'desktop',
  fullScreenDialog: false,
  fixedCloseButton: false,
  preventBackButton: false,
  colorConfig: colors
});

export default Modal;